import { storage } from '../storage';
export const getPayParams = (xenv) => {
    const params = {
        passenger: {
            options: {
                out_token: storage.userInfo.token,
            },
        },
        esapp: {
            options: {
                token: storage.userInfo.token,
                appid: 'wxe9875a55496b6b34',
            },
            version: '1.1.2',
        },
        driver: {
            options: {
                token: storage.userInfo.token,
                appid: 'wx2361002281651a46',
            },
            version: '1.1.9',
        },
        hywxmp: {
            options: {
                token: storage.userInfo.token,
                appid: 'wxab1642da834a1339',
            },
            mini_url: '/cashier-page/pages/index',
        },
        hyalimp: {
            options: {
                token: storage.userInfo.token,
                appid: '2021002110647578',
            },
            mini_url: '/cashier-page/pages/index',
        },
        cralimp: {
            options: {
                token: storage.userInfo.token,
                appid: '2021003180611013',
            },
            config: {
                business: 'cralimp',
            },
            mini_url: '/cashier-page/pages/index',
        },
        dymp: {
            options: {
                token: storage.userInfo.token,
                appid: 'ttc4c2b27f5bfd0d8701',
                tc_terminal: '132-10030-000',
            },
            mini_url: '/cashier-page/pages/index',
        },
        wxmp: {
            options: {
                token: storage.userInfo.token,
            },
            mini_url: '/cashier-page/pages/index',
        },
        h5: {
            options: {
                token: storage.userInfo.token,
            },
            config: {
                sponsorType: {
                    aliPay: 16
                }
            },
            version: '1.1.1',
        },
        default: {}
    };
    return params[xenv] || params['default'];
};
export const passengerFormat = {
    options: {
        out_trade_id: '',
        out_token: '',
        wx_app_id: '',
        wxAppID: '',
    },
};
export const miniProgramFormat = {
    options: {
        appid: '',
        token: '',
        open_id: '',
        out_trade_id: '',
        phone: '',
        uid: '',
        tc_terminal: '',
    },
    config: {
        env: '',
        subEnv: '',
        diyHost: '',
        bgColor: '',
        useCustomH5: '',
        needRefresh: '',
        business: '',
        timer: '',
        isAllowDoPay: '',
        clientSource: '',
    },
    mini_url: '',
    successUrl: '',
    failUrl: '',
    jumpType: '',
};
export const h5Format = {
    options: {
        appid: '',
        token: '',
        open_id: '',
        out_trade_id: '',
        return_url: '',
        alipaySchema: '',
    },
    config: {
        env: '',
        subEnv: '',
        diyHost: '',
        scene: '',
        bgColor: '',
        useCustomH5: '',
        runtime: '',
        sponsorType: '',
        prePay: '',
        traceColor: ''
    },
    version: ''
};
